import styled from 'styled-components';
import IconArrowDown from './IconArrowDown';
var IconArrowRight = /*#__PURE__*/styled(IconArrowDown).withConfig({
  displayName: "IconArrowRight",
  componentId: "c11n-8-107-0__sc-1bez2s0-0"
})(["transform:rotate(270deg);"]);
export default IconArrowRight;